<template>
  <d-card class="card-small mb-3">
    <d-card-header class="border-bottom">
      <h6 class="m-0">Ações</h6>
    </d-card-header>
    <d-card-body class="px-0">
      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-button class="btn-danger btn-block" @click="confirmDeleteRow()">
            Excluir Gerente
          </d-button>
        </d-list-group-item>
      </d-list-group>
    </d-card-body>
    <d-card-footer class="border-top">
      <d-button class="btn-dark btn-block" @click="goBack">Voltar</d-button>
      <d-button class="btn-primary btn-block" @click="save()">Salvar</d-button>
    </d-card-footer>
  </d-card>
</template>

<script>
import Events from '_utils/events';
import { MODEL, _DELETE_MANAGER_ } from './ManagerModel';

export default {
  name: 'sidebar-actions',
  components: {},
  props: {
    model: {
      type: Object,
      default: () => MODEL,
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    save() {
      this.$emit('save', this.model);
    },
    confirmDeleteRow() {
      Events.$emit(_DELETE_MANAGER_, this.model);
    },
  },
};
</script>
